'use client';

import React from 'react';

interface DrawerProps {
  isOpen: boolean;
  drawerComponent: React.ReactNode;
}

/**
 * [共通]ドロワーコンポーネント
 * @param param0
 * @returns
 */
const Drawer: React.FC<DrawerProps> = ({ isOpen, drawerComponent }) => {
  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black opacity-25 z-20"></div>}

      <div
        className={`fixed inset-x-0 z-20 bottom-0 h-[98dvh] transform transition-transform duration-200 ease-in-out ${
          isOpen ? 'translate-y-0' : 'translate-y-full'
        }`}>
        {drawerComponent}
      </div>
    </>
  );
};

export default Drawer;
